import Quill from 'quill';

const Parchment = Quill.import('parchment');

const LetterSpacing = new Parchment.Attributor.Style(
  'customLetterSpacing',
  'letter-spacing',
  {
    scope: Parchment.Scope.BLOCK,
  },
);

export default LetterSpacing;
